module.exports = __webpack_public_path__ + "img/farzana-christopher-107.ce2abe6d.jpg";